export const stickyElementsThresholds = {
    maxWindowWidth: 767,
};
